import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from '@michelin/central-provider';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    padding: '14px 20px',
    background: '#0b2e59',
    color: '#fff',
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
  },
  eyebrow: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: '#b7c4d6',
    marginBottom: 4,
  },
  stepCount: {
    fontSize: 15,
    fontWeight: 700,
    color: '#fce500',
  },
  closeButton: {
    flexShrink: 0,
    padding: '6px 10px',
    fontSize: 12,
    fontWeight: 700,
    fontFamily: 'inherit',
    color: '#fff',
    background: 'rgba(255, 255, 255, 0.08)',
    border: '1px solid rgba(255, 255, 255, 0.35)',
    borderRadius: 20,
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.18)',
    },
  },
}));

export interface HeaderProps {
  index: number;
  total: number;
  onClose?: () => void;
}

export function Header({ index, total, onClose }: HeaderProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.header}>
      <div className={classes.text}>
        <span className={classes.eyebrow}>{t('Michelin Services Platform 3.0 \u00B7 Platform Tour')}</span>
        <span className={classes.stepCount}>{t('Step {{index}} of {{total}}', { index: index + 1, total })}</span>
      </div>
      {onClose && (
        <button type="button" className={classes.closeButton} onClick={onClose}>
          {t('\u2715 Close tour')}
        </button>
      )}
    </div>
  );
}

export default Header;
